<div class="heading_sert">
  <sm-title-bar
    pageTitle="Member details"
    [back]="true"
    [headerCustomTemplate]="addButton"
  >
    <ng-template #addButton>
      <div class="search_pag">
        <div class="opert_section">
          <button
            mat-icon-button
            class="more-button"
            aria-label="More options"
            [matMenuTriggerFor]="menu1"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #menu1="matMenu">
            <button
              mat-menu-item
              (click)="createInvoiceForEnrolled(memberDetailsData)"
              *ngIf="
                memberDetailsData.membership_status != 2 &&
                getInvoiceAccess(memberDetailsData.service_mode)
              "
            >
              <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
              <span>Create membership invoice</span>
            </button>
            <button mat-menu-item (click)="openAllInvoices(memberDetailsData)">
              <mat-icon class="material-icons-outlined">receipt</mat-icon>
              <span>See all payments</span>
            </button>
            <button mat-menu-item (click)="openDueInvoices(memberDetailsData)">
              <mat-icon class="material-icons-outlined"
                >pending_actions</mat-icon
              >
              <span>See due payments</span>
            </button>

            <button mat-menu-item (click)="openwallemoney(memberDetailsData)">
              <mat-icon class="material-icons-outlined">wallet</mat-icon>
              <span>Wallet money</span>
            </button>
            <button mat-menu-item (click)="openrewardpoint(memberDetailsData)">
              <mat-icon class="material-icons-outlined">card_giftcard</mat-icon>
              <span>Reward points</span>
            </button>
            <!-- <button mat-menu-item>
              <mat-icon class="material-icons-outlined"
                >notification_add</mat-icon
              >
              <span>Auto reminders</span>
            </button> -->
            <button
              mat-menu-item
              (click)="openPaymentIntimation(memberDetailsData)"
              *ngIf="memberDetailsData.total_due > 0 && isOwner"
            >
              <mat-icon class="material-icons-outlined">share</mat-icon>
              <span>Send payment intimation</span>
            </button>
            <button mat-menu-item (click)="editMember()" *ngIf="isOwner">
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span>Edit all data </span>
            </button>
            <button
              mat-menu-item
              (click)="
                updateEnrolledMemberMembershipStatus(memberDetailsData, 1)
              "
              *ngIf="memberDetailsData.membership_status == 2 && isOwner"
            >
              <mat-icon class="material-icons-outlined">cancel</mat-icon>
              <span>Revive membership</span>
            </button>
            <button
              mat-menu-item
              (click)="
                updateEnrolledMemberMembershipStatus(memberDetailsData, 2)
              "
              *ngIf="memberDetailsData.membership_status == 1 && isOwner"
            >
              <mat-icon class="material-icons-outlined">cancel</mat-icon>
              <span>Cancel membership</span>
            </button>
            <button
              mat-menu-item
              (click)="deleteMember(memberDetailsData)"
              *ngIf="isOwner"
            >
              <mat-icon class="material-icons-outlined">delete</mat-icon>
              <span> Delete member</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </ng-template>
  </sm-title-bar>
</div>

<div class="member_details_view" *ngIf="!loader">
  <div class="container">
    <div class="row">
      <div class="col-sm-8">
        <!-- <div class="right_deatils_pp">
           <div class="service_info">
              <div class="member_det_og">
                       <div class="service_listh" style="border: none;">
                          <div class="bus_hjk">
                             <h4>Membership start date
                             </h4>
                             <mat-chip-list aria-label="Fish selection">
                                <mat-chip class="primary">20 Dec 2024</mat-chip>
                             </mat-chip-list>
                          </div>
                       </div>
                     </div>
                   </div>
                 </div> -->

        <div class="salon_mei_section">
          <mat-card>
            <div class="exert_opd">
              <div
                class="opert_section"
                style="margin-right: 22px; padding-top: 10px"
              >
                <button
                  mat-icon-button
                  [matMenuTriggerFor]="menu2"
                  class="more-button"
                  aria-label="More options"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu2="matMenu">
                  <button
                    mat-menu-item
                    (click)="editMemberPersonalData()"
                    *ngIf="isOwner"
                  >
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                    <span>Edit personal data </span>
                  </button>

                  <button
                    mat-menu-item
                    (click)="opentrack()"
                    *ngIf="
                      isEntityIndividual == '1' &&
                      memberDetailsData.membership_status == 1
                    "
                  >
                    <mat-icon class="material-icons-outlined"
                      >assessment</mat-icon
                    >
                    <span>Show fitness data</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="openViewAttendance(memberDetailsData)"
                    *ngIf="isEntityIndividual == '1'"
                  >
                    <mat-icon class="material-icons-outlined"
                      >fact_check</mat-icon
                    >
                    <span>View attendance</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="openmarkabsent(memberDetailsData)"
                    *ngIf="
                      isEntityIndividual == '1' &&
                      memberDetailsData.membership_status != 2
                    "
                  >
                    <mat-icon class="material-icons-outlined"
                      >disabled_by_default</mat-icon
                    >
                    <span>Mark absent</span>
                  </button>
                  <button
                    mat-menu-item
                    (click)="onChangePhoneNumber()"
                    *ngIf="isOwner"
                  >
                    <mat-icon class="material-icons-outlined"
                      >mobile_friendly</mat-icon
                    >
                    <span>Change phone number </span>
                  </button>
                </mat-menu>
              </div>
              <div class="member_details_iopen">
                <div class="salon_img">
                  <img
                    [src]="memberDetailsData.image_thumb_url"
                    onerror="
                      this.src = '../../../../assets/images/user-avatar.svg'
                    "
                    alt=""
                  />
                </div>
                <div class="fill_section">
                  <div class="hair_ct_heading">
                    <div class="rahul_headert">
                      <h4>{{ memberDetailsData.name }}</h4>
                      <p>
                        {{ memberDetailsData.country_code }}
                        {{ memberDetailsData.phone }}
                      </p>
                    </div>
                  </div>
                  <div class="rahul_headert menbrtr">
                    <div class="new_employ">
                      <p>
                        {{
                          memberDetailsData.address &&
                          memberDetailsData.address != "null" &&
                          memberDetailsData.address != ""
                            ? memberDetailsData.address
                            : "No address added"
                        }}
                      </p>
                      <p>
                        {{
                          memberDetailsData.email
                            ? memberDetailsData.email
                            : "No email added"
                        }}
                      </p>
                    </div>
                    <div class="new_employ">
                      <!-- Gender: -->

                      <p>
                        DOB -
                        {{
                          memberDetailsData.dob
                            ? (memberDetailsData.dob | date)
                            : "--"
                        }}
                      </p>
                      <p *ngIf="memberDetailsData.gender">
                        {{ memberDetailsData.gender }}
                      </p>
                    </div>
                  </div>
                  <div class="track_btnert">
                    <div
                      class="chatnow_btn_sed"
                      style="
                        padding-left: 0px !important;
                        margin-right: 10px;
                        margin-top: 0px;
                      "
                      *ngIf="
                        isEntityIndividual == '1' &&
                        memberDetailsData.membership_status == 1
                      "
                    >
                      <button mat-flat-button (click)="opentrack()">
                        Fitness data <mat-icon>arrow_forward</mat-icon>
                      </button>
                    </div>

                    <div
                      class="chatnow_outline"
                      *ngIf="
                        memberDetailsData.profile_hash &&
                        memberDetailsData.profile_hash != 'null'
                      "
                    >
                      <button
                        mat-flat-button
                        (click)="openMessages(memberDetailsData)"
                      >
                        Chat now
                        <mat-icon>send</mat-icon>
                      </button>
                    </div>
                  </div>

                  <!-- <div class="flex_img">
                   <img
                    src="https://imgs.search.brave.com/z98IraXp1nTbNRBFio6H3A7xc6gP_vko6WOQO92Bo7o/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly93d3cu/dW5pcW9kZS5jb20v/YmxvZy93cC1jb250/ZW50L3RoZW1lcy9i/ZWFjb25zdGFjL2lt/Zy9oZWFkZXIvcXIt/dGVtcGxhdGUtNC53/ZWJw"
                    alt=""
                  />
                  </div> -->
                </div>
              </div>

              <div
                class="active_cardt"
                style="display: flex"
                *ngIf="memberDetailsData.membership_status == 1"
              >
                <p style="margin-right: 35px">
                  <span class="activemember"></span>
                  <span class="member_list">Active</span>
                </p>
                <p style="margin-right: 35px">
                  <span class="waletstatucmember"></span>
                  <span
                    class="member_list"
                    *ngIf="memberDetailsData?.total_wallet?.wallet_total_amount"
                    >Wallet money: {{ memberDetailsData.currency_symbol
                    }}{{
                      memberDetailsData.total_wallet.wallet_total_amount.toFixed(
                        2
                      )
                    }}</span
                  >
                  <span
                    class="member_list"
                    *ngIf="
                      !memberDetailsData?.total_wallet?.wallet_total_amount
                    "
                    >Wallet money:
                    {{ memberDetailsData.currency_symbol }}0.00</span
                  >
                </p>
                <p>
                  <span class="waletstatucmember"></span>
                  <span class="member_list"
                    >Reward point:
                    {{
                      memberDetailsData.total_reward
                        ? memberDetailsData.total_reward
                        : 0
                    }}</span
                  >
                </p>
              </div>
              <div
                class="inactive_cardt"
                *ngIf="memberDetailsData.membership_status == 2"
              >
                <p>
                  <!-- <mat-icon role="img" class="mat-icon notranslate material-icons mat-icon-no-color" aria-hidden="true"
                          data-mat-icon-type="font">cancel</mat-icon> -->
                  <span class="inactivemember"></span>
                  <span class="member_list"> This member is inactive </span>
                </p>
              </div>
            </div>
          </mat-card>
        </div>

        <div
          class="alert-number alert_number_tt"
          *ngIf="memberDetailsData.dispute_status === 2"
        >
          <div class="alert-number__content">
            <div class="alert-number__icon">
              <mat-icon>error</mat-icon>
            </div>

            <div class="alert-number__text">
              <p class="alert-number__title">
                The user associated with this member's phone number declined the
                membership.
              </p>
              <p class="alert-number__subtitle">
                If the decline was accidental, re-send invitation or change the
                phone number.
              </p>
            </div>
          </div>

          <button
            mat-icon-button
            [matMenuTriggerFor]="menu3"
            class="alert-number__more"
            aria-label="More options"
          >
            <mat-icon>more_vert</mat-icon>
          </button>
          <!-- DONT TOUCH THIS -->
          <mat-menu #menu3="matMenu">
            <button mat-menu-item (click)="onResend()">
              <mat-icon class="material-icons-outlined">cached</mat-icon>
              <span>Re-send invitation</span>
            </button>

            <button
              mat-menu-item
              (click)="onChangePhoneNumber()"
              *ngIf="isOwner"
            >
              <mat-icon class="material-icons-outlined">edit</mat-icon>
              <span>Change phone number</span>
            </button>
          </mat-menu>
        </div>

        <div class="workout_timiing_open" *ngIf="isEntityIndividual == '1'">
          <div class="opert_section peoplper">
            <button
              mat-icon-button
              class="more-button"
              aria-label="More options"
              [matMenuTriggerFor]="menu4"
            >
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu4="matMenu">
              <button
                mat-menu-item
                (click)="editMemberOptedTimings()"
                [disabled]="!isOwner"
              >
                <mat-icon class="material-icons-outlined">edit</mat-icon>
                <span>Add/edit timings </span>
              </button>
            </mat-menu>
          </div>
          <div class="booking_name_opop">
            <h1>Opted timings</h1>
          </div>
          <mat-chip-list aria-label="service mode">
            <mat-chip
              style="color: #212121 !important"
              *ngFor="let item of memberDetailsData.opted_timings"
            >
              {{ item }}
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="right_deatils_pp">
          <!-- Opted services start -->
          <div class="sub_ser">
            <div class="opert_section peoplper">
              <button
                mat-icon-button
                class="more-button"
                aria-label="More options"
                [matMenuTriggerFor]="menu5"
              >
                <mat-icon>more_vert</mat-icon>
              </button>

              <mat-menu #menu5="matMenu">
                <button
                  mat-menu-item
                  (click)="editMemberServicePackage()"
                  [disabled]="!isOwner"
                >
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                  <span>Add/edit package </span>
                </button>
              </mat-menu>
            </div>
            <h3 class="sub_headingt">Opted service / package</h3>
            <div class="service_mode_chip" *ngIf="memberDetailsData.services">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of memberDetailsData.services"
                >
                  <div class="service_listh">
                    <div
                      class="bus_img"
                      *ngIf="item.img_url && item.img_url != 'null'"
                    >
                      <img
                        [src]="item.img_url"
                        onerror="
                          this.src = '../../../../assets/images/photo.png'
                        "
                        alt=""
                      />
                    </div>
                    <div
                      class="placeholder_headingv"
                      *ngIf="!item.img_url || item.img_url == 'null'"
                    >
                      <p>{{ item.service_name.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.service_name }} X {{ item.service_qty }}
                      </h4>
                      <p>
                        {{ item.currency_symbol }}{{ item.rate.toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="service_mode_chip" *ngIf="!memberDetailsData.services">
              <div class="row">
                <p>No service opted</p>
              </div>
            </div>
          </div>
          <!-- Opted services end -->
          <!-- opted product start -->
          <div class="sub_ser">
            <h3 class="sub_headingt">Opted products</h3>
            <div class="service_mode_chip" *ngIf="memberDetailsData.products">
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of memberDetailsData.products"
                >
                  <div class="service_listh">
                    <div
                      class="bus_img"
                      *ngIf="item.img_url && item.img_url != 'null'"
                    >
                      <img
                        [src]="item.img_url"
                        onerror="
                          this.src = '../../../../assets/images/photo.png'
                        "
                        alt=""
                      />
                    </div>
                    <div
                      class="placeholder_headingv"
                      *ngIf="!item.img_url || item.img_url == 'null'"
                    >
                      <p>{{ item.product_name.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.product_name }} X {{ item.product_qty }}
                      </h4>
                      <p>
                        {{ item.currency_symbol }}{{ item.rate.toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="service_mode_chip" *ngIf="!memberDetailsData.products">
              <div class="row">
                <p>No product opted</p>
              </div>
            </div>
          </div>
          <!-- opted product end -->
          <!-- Other items start -->
          <div class="sub_ser">
            <h3 class="sub_headingt">Other items</h3>
            <div
              class="service_mode_chip"
              *ngIf="memberDetailsData.custom_items"
            >
              <div class="row">
                <div
                  class="col-sm-4"
                  *ngFor="let item of memberDetailsData.custom_items"
                >
                  <div class="service_listh">
                    <div class="placeholder_headingv">
                      <p>{{ item.item_name.slice(0, 1).toUpperCase() }}</p>
                    </div>
                    <div class="bus_hjk">
                      <h4 class="prodcut_heading">
                        {{ item.item_name }} X {{ item.item_qty }}
                      </h4>
                      <p>
                        {{ item.currency_symbol
                        }}{{ item.item_price.toFixed(2) }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="service_mode_chip"
              *ngIf="!memberDetailsData.custom_items"
            >
              <div class="row">
                <p>No other items</p>
              </div>
            </div>
          </div>

          <!-- Other items end -->
          <!-- coupon section start -->
          <!-- <div class="sub_ser" *ngIf="memberDetailsData.coupon_code">
              <h3 class="sub_headingt">Coupon applied
              </h3>
              <div class="service_mode_chip" >
                 <div class="row">
                    <div class="col-sm-4">
                       <div  class="service_listh" style="border-right: none;">
                          <div  class="bus_icon">
                           <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 30 30" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M21.321 15.719c-3.01.072-3.015 4.484-.006 4.564 3.01-.073 3.014-4.483.006-4.564zm-.785 2.285c.001-1.024 1.558-1.028 1.564-.004-.004 1.021-1.556 1.025-1.564.004zM15.32 14.281c3.009-.076 3.009-4.488 0-4.564-3.01.077-3.008 4.486 0 4.564zm0-3.063c1.023.004 1.023 1.56 0 1.564-1.023-.005-1.022-1.558 0-1.564zM23.19 10.138a.753.753 0 0 0-1.064-.002l-8.69 8.649a.75.75 0 1 0 1.058 1.063l8.691-8.648a.75.75 0 0 0 .005-1.062zM8.852 10.537a.75.75 0 0 0-.75.75v1.923a.75.75 0 0 0 1.5 0v-1.923a.75.75 0 0 0-.75-.75zM8.852 16.041a.75.75 0 0 0-.75.75v1.922a.75.75 0 0 0 1.5 0v-1.922a.75.75 0 0 0-.75-.75z" fill="#383838" opacity="1" data-original="#000000" class=""></path><path d="M28.379 12.522a2.6 2.6 0 0 0 1.371-2.3V7.65a2.62 2.62 0 0 0-2.617-2.617H2.867A2.62 2.62 0 0 0 .25 7.65v2.57a2.6 2.6 0 0 0 1.371 2.3 2.812 2.812 0 0 1 0 4.958A2.6 2.6 0 0 0 .25 19.78v2.57a2.62 2.62 0 0 0 2.617 2.617h24.266a2.62 2.62 0 0 0 2.617-2.617v-2.57a2.6 2.6 0 0 0-1.371-2.3c-1.964-.983-1.949-3.975 0-4.958zm-2.47 4.512a4.307 4.307 0 0 0 1.764 1.764c.359.194.581.57.577.978v2.57a1.118 1.118 0 0 1-1.117 1.117H9.6c-.041-.65.258-1.894-.75-1.919-1.009.024-.709 1.274-.75 1.923H2.867A1.118 1.118 0 0 1 1.75 22.35v-2.57a1.099 1.099 0 0 1 .577-.978 4.311 4.311 0 0 0 0-7.6 1.099 1.099 0 0 1-.577-.978V7.65c.001-.617.5-1.116 1.117-1.117H8.1c.041.651-.26 1.898.75 1.923 1.009-.024.709-1.274.75-1.923h17.533c.617.001 1.116.5 1.117 1.117v2.57c.004.408-.218.784-.577.978a4.31 4.31 0 0 0-1.764 5.836z" fill="#383838" opacity="1" data-original="#000000" class=""></path></g></svg>
                          </div>
                          <div class="bus_hjk">
                             <h4 class="prodcut_heading">{{memberDetailsData.coupon_code}}
                             </h4>
                             <p> 
                                {{memberDetailsData.currency_symbol}}{{memberDetailsData.discount_amount ? memberDetailsData.discount_amount.toFixed(2) : '0.00'}}
                             </p>
                          </div>
                       </div>
                    </div>
                 </div>
              </div>
           </div> -->
          <!-- coupon section end -->
        </div>
        <div class="workout_timiing_open">
          <div class="booking_name_opop">
            <h1 style="margin-bottom: 6px">Notes</h1>
          </div>
          <div class="member_paragr">
            <p>
              {{
                memberDetailsData.notes
                  ? memberDetailsData.notes
                  : "No notes added"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-sm-4">
        <div
          class="trainer_start"
          *ngIf="
            memberDetailsData.assign_to && memberDetailsData.assign_to != 'null'
          "
        >
          <mat-card>
            <div class="main_headingrt">
              <h1>{{ isEntityIndividual == "1" ? "Trainer" : "Attendee" }}</h1>
            </div>
            <div class="trainer_list">
              <div class="trainer_img">
                <img
                  [src]="memberDetailsData.assign_to.thumb_image"
                  onerror="
                    this.src = '../../../../assets/images/user-avatar.svg'
                  "
                  alt=""
                />
              </div>
              <div class="trainer_heading">
                <h3>{{ memberDetailsData.assign_to.name }}</h3>
                <p>
                  {{ memberDetailsData.assign_to.country_code }}
                  {{ memberDetailsData.assign_to.phone }}
                </p>
              </div>
            </div>
          </mat-card>
        </div>
        <div class="right_deatils_pp servicemode">
          <div class="service_info">
            <div class="member_det_og">
              <div class="service_listh" style="border: none">
                <div class="bus_hjk" style="padding-right: 3px">
                  <h4>Service mode</h4>
                  <mat-chip-list aria-label="Fish selection">
                    <mat-chip
                      class="primary"
                      style="
                        width: max-content;
                        background: #ffc107;
                        color: #fff !important;
                      "
                      >{{ memberDetailsData.s_mode }}
                    </mat-chip>
                  </mat-chip-list>
                </div>
                <div class="bus_hjk" style="">
                  <h4>Billing cycle</h4>
                  <mat-chip-list aria-label="Fish selection">
                    <mat-chip
                      class="primary"
                      *ngIf="memberDetailsData.billing_period == 1"
                      >Weekly
                    </mat-chip>
                    <mat-chip
                      class="primary"
                      *ngIf="memberDetailsData.billing_period == 2"
                      >Monthly
                    </mat-chip>
                    <mat-chip
                      class="primary"
                      *ngIf="memberDetailsData.billing_period == 3"
                      >Yearly
                    </mat-chip>
                    <mat-chip
                      class="primary"
                      *ngIf="memberDetailsData.billing_period == 4"
                      >3 Months
                    </mat-chip>
                    <mat-chip
                      class="primary"
                      *ngIf="memberDetailsData.billing_period == 5"
                      >6 Months
                    </mat-chip>
                  </mat-chip-list>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="coupon_applied"
          *ngIf="
            memberDetailsData.coupon_code &&
            memberDetailsData.coupon_code != '' &&
            memberDetailsData.coupon_code != 'null'
          "
        >
          <mat-card>
            <div class="coupon-card">
              <h3>Coupon applied</h3>
              <div class="coupon-row">
                <span id="cpnCode">{{ memberDetailsData.coupon_code }}</span>
                <span
                  style="all: unset; margin-left: 5px"
                  *ngIf="
                    memberDetailsData?.coupon_use_limit != 0 &&
                    memberDetailsData?.coupon_use_limit ==
                      memberDetailsData?.coupon_use_counter
                  "
                  >(Expired)</span
                >
                <!-- <span id="cpnBtn">Copy Code</span> -->
              </div>
              <div class="circle1"></div>
              <div class="circle2"></div>
            </div>
          </mat-card>
        </div>

        <div
          class="order_summary_section"
          style="margin-bottom: 20px"
          *ngIf="
            trackersData.length > 0 && memberDetailsData.membership_status == 1
          "
        >
          <mat-card>
            <div class="booking_name_opop">
              <h1 style="font-weight: normal; margin-bottom: 20px">
                Fitness data
              </h1>
            </div>
            <div class="shop_flexc" *ngFor="let item of trackersData">
              <div class="clrt_heading">
                {{ item.tracking_item_name | titlecase }}
              </div>
              <div>
                {{
                  item.item_current_value
                    ? item.item_current_value
                    : item.tracking_logs
                      ? item.sortedLogs[0].tracking_item_value
                      : "---"
                }}
                {{
                  item.item_current_value || item.tracking_logs
                    ? item.measurement_unit
                    : ""
                }}
              </div>
            </div>

            <div class="shop_flex servi_border newflex">
              <div class="texhesdingt">
                Last update date:
                {{ latestDate ? (latestDate | date: "d MMM, y") : "---" }}
              </div>
              <div
                class="progress-data_icon"
                style="
                  cursor: pointer;
                  display: flex;
                  cursor: pointer;
                  position: relative;
                  top: 2px;
                "
                (click)="opentrack()"
              >
                <mat-icon>arrow_forward</mat-icon>
              </div>
            </div>
          </mat-card>
        </div>
        <div
          class="trainer_start"
          *ngIf="
            memberDetailsData.member_address &&
            memberDetailsData.member_address != 'null' &&
            memberDetailsData.member_address != '' && memberDetailsData.service_mode == 0
          "
        >
          <mat-card
            appearance="outlined"
            class="addewsas"
            style="padding-bottom: 8px"
          >
          <div
            class="opert_section"
            style="margin-right: 0px !important;"
          >
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu2"
              class="more-button"
              aria-label="More options"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu2="matMenu">
              <button
                mat-menu-item
                (click)="editAddress()"
                [disabled]="!isOwner"
              >
                <mat-icon class="material-icons-outlined">edit</mat-icon>
                <span>Edit address</span>
              </button>
            </mat-menu>
          </div>
            <div class="main_headingrt">
              <h1 style="margin-bottom: 2px">Member address</h1>
            </div>
            <p
              style="white-space: pre-line; margin-bottom: 5px; color: #888"
              *ngIf="
                memberDetailsData.member_address.house_no ||
                memberDetailsData.member_address.street_name
              "
            >
              <span *ngIf="memberDetailsData.member_address.house_no"
                >{{ memberDetailsData.member_address.house_no }},
              </span>
              <span *ngIf="memberDetailsData.member_address.street_name">{{
                memberDetailsData.member_address.street_name
              }}</span>
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888">
              {{ memberDetailsData.member_address.city }},
              {{ memberDetailsData.member_address.state }}, PIN/ZIP:
              {{ memberDetailsData.member_address.zip }}
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888">
              {{ memberDetailsData.member_address.address_line }}
            </p>
            <p
              style="white-space: pre-line; margin-bottom: 5px; color: #888"
              *ngIf="memberDetailsData.member_address.landmark"
            >
              Landmark: {{ memberDetailsData.member_address.landmark }}
            </p>
            <p
              *ngIf="memberDetailsData.member_address.phone"
              style="white-space: pre-line; margin-bottom: 5px; color: #888"
            >
              Contact phone: {{ memberDetailsData.member_address.country_code }}
              {{ memberDetailsData.member_address.phone }}
            </p>

            <div
              class="flex_uner_flex"
              (click)="openGoogleMaps(memberDetailsData.member_address)"
            >
              <div class="view_on_map_btn">
                <p>View on map</p>
              </div>
              <div class="arrow_map_icon">
                <mat-icon>arrow_forward</mat-icon>
              </div>
            </div>
          </mat-card>
        </div>
        <div
          class="trainer_start"
          *ngIf="
            memberDetailsData.online_session_link &&
            memberDetailsData.online_session_link != 'null' &&
            memberDetailsData.online_session_link != '' && memberDetailsData.service_mode == 2
          "
        >
         
          <mat-card
            appearance="outlined"
            class="addewsas"
            style="padding-bottom: 8px"
          >
             <div
            class="opert_section"
            style="margin-right: 0px !important;"
          >
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu2"
              class="more-button"
              aria-label="More options"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu2="matMenu">
              <button
                mat-menu-item
                (click)="editSessionInfo()"
                [disabled]="!isOwner"
              >
                <mat-icon class="material-icons-outlined">edit</mat-icon>
                <span>Edit meeting info</span>
              </button>
            </mat-menu>
          </div>
            <div class="main_headingrt">
              <h1 style="margin-bottom: 2px">Virtual session info</h1>
            </div>

            <p style="white-space: pre-line; margin-bottom: 5px; color: #888;margin-top: 10px;">
              Online meeting link:
              <a
                href="javascript:void(0)"
                style="color: #888"
                (click)="openLink(memberDetailsData.online_session_link)"
                >{{ memberDetailsData.online_session_link }}</a
              >
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888;word-wrap: break-word;margin-top: 10px;">
              App download:
              {{
                memberDetailsData.online_session_app &&
                memberDetailsData.online_session_app != "" &&
                memberDetailsData.online_session_app != "null"
                  ? memberDetailsData.online_session_app
                  : "---"
              }}
            </p>
            <p style="white-space: pre-line; margin-bottom: 5px; color: #888;margin-top: 10px;">
              Other session info:
              {{
                memberDetailsData.online_session_notes &&
                memberDetailsData.online_session_notes != "" &&
                memberDetailsData.online_session_notes != "null"
                  ? memberDetailsData.online_session_notes
                  : "---"
              }}
            </p>
          </mat-card>
        </div>
        <div class="order_summary_section">
          <mat-card>
            <div class="booking_name_opop">
              <h1 style="font-weight: normal; margin-bottom: 20px">
                Subscription fees
              </h1>
            </div>
            <div class="shop_flexc">
              <div class="clrt_heading">Total cost</div>
              <div>
                {{ memberDetailsData.currency_symbol
                }}{{
                  memberDetailsData.membership_fee
                    ? (+memberDetailsData.membership_fee).toFixed(2)
                    : "0.00"
                }}
              </div>
            </div>
            <div class="shop_flexc">
              <div class="clrt_heading">Discount</div>
              <div>
                {{ memberDetailsData.currency_symbol
                }}{{
                  memberDetailsData.discount
                    ? (+memberDetailsData.discount).toFixed(2)
                    : "0.00"
                }}
              </div>
            </div>
            <div
              class="shop_flexc"
              *ngIf="
                memberDetailsData.coupon_code &&
                (memberDetailsData?.coupon_use_limit == 0 ||
                  memberDetailsData?.coupon_use_counter <
                    memberDetailsData?.coupon_use_limit)
              "
            >
              <div class="clrt_heading">Coupon Discount</div>
              <div>
                {{ memberDetailsData.currency_symbol
                }}{{
                  memberDetailsData.discount_amount
                    ? (+memberDetailsData.discount_amount).toFixed(2)
                    : "0.00"
                }}
              </div>
            </div>
            <div class="shop_flexc servi_border">
              <div class="clrt_heading">Net payable</div>
              <div class="price_oper">
                {{ memberDetailsData.currency_symbol
                }}{{
                  memberDetailsData.net_payable
                    ? (+memberDetailsData.net_payable).toFixed(2)
                    : "0.00"
                }}
              </div>
            </div>
            <div class="shop_flex servi_border">
              <div class="texhesdingt">
                Subscription start date:
                {{
                  memberDetailsData.membership_start_date
                    ? (memberDetailsData.membership_start_date | date)
                    : "--"
                }}
              </div>
              <div
                class="texhesdingt"
                style="margin-top: 10px"
                *ngIf="
                  memberDetailsData?.pay_in_advance == 1 &&
                  memberDetailsData?.pay_in_advance
                "
              >
                Payment mode: Advance
              </div>
              <!-- <div
                class="texhesdingt"
                style="margin-top: 10px"
                *ngIf="
                  memberDetailsData.membership_status == 2 &&
                  memberDetailsData.membership_end_date
                "
              >
                Subscription end date:
                {{
                  memberDetailsData.membership_end_date
                    ? (memberDetailsData.membership_end_date | date)
                    : "--"
                }}
              </div> -->
            </div>
            <div
              style="padding-top: 0; margin-top: 10px"
              class="shop_flex servi_border"
              *ngIf="
                memberDetailsData.membership_status == 2 &&
                memberDetailsData.membership_end_date
              "
            >
              <div class="texhesdingt" style="margin-top: 10px">
                Subscription end date:
                {{
                  memberDetailsData.membership_end_date
                    ? (memberDetailsData.membership_end_date | date)
                    : "--"
                }}
              </div>
            </div>
          </mat-card>
        </div>

        <!-- <div class="booking_detail_info">
      <p>Body & Soul Sha Center</p>
      <p class="address_frt">Software Technology Parks of India, Sahid Sukumar Banerjee Sarani, opposite of Spencers, Bidhannagar, Durgapur, West Bengal 713212</p>
      </div> -->
      </div>
    </div>
  </div>
  <!-- </div> -->
</div>
